/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventDtoByDateRrule } from './eventDtoByDateRrule';


/**
 * (tsType: EventDtoWithRelations, schemaOptions: { title: \'EventDtoByDate\', includeRelations: true })
 */
export interface EventDtoByDate { 
  [key: string]: any | any;


    id: string;
    title: string;
    start: string;
    end?: string;
    color?: string;
    groupId?: string;
    rrule?: EventDtoByDateRrule;
    description?: string;
    url?: string;
}

